import { createIcon } from '@chakra-ui/react';

export const SharedIconStripe = createIcon({
  displayName: 'SharedIconStripe',
  viewBox: '0 0 13 4',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: [<rect x={0.137} y={0.273} width={12} height={3} rx={1.5} fill="currentColor" />]
});
